export const normalizePropertyName = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '')

export const makeUniquePropertyName = (
  baseName: string,
  existingNames: ReadonlySet<string>,
): string => {
  if (!baseName || !existingNames.has(baseName)) {
    return baseName
  }

  let suffix = 2
  let candidate = `${baseName}_${suffix}`
  while (existingNames.has(candidate)) {
    suffix++
    candidate = `${baseName}_${suffix}`
  }
  return candidate
}
